import { useFormikContext } from "formik";
import { SealRegistrationFormData, getDonationAmount } from "../SealRegistrationContext";
import { SealPaymentSummary } from "../components/SealPaymentSummary";

export const RegistrationTotalSection = () => {
  const { values } = useFormikContext<SealRegistrationFormData>();
  const donationAmount = getDonationAmount(values);

  return (
    <div className="seal-form-section seal-form-section--bordered">
      <h2 className="sub-headline">Registration total</h2>

      <SealPaymentSummary donationAmount={donationAmount} />

      <p className="form-fields-sub-text" style={{ marginTop: "12px" }}>
        The US $300 one-time fee covers the single wine brand, vineyard business,
        importing business, or retail business named in this registration.
      </p>
      <p className="form-fields-sub-text">
        Additional wine brands require separate registrations. There are no annual
        renewal fees.
      </p>
      <p className="form-fields-sub-text">
        * The Old Vine Registry Foundation is a registered 501(c)3 Tax Exempt non-profit with EIN: #42-4790618. Tax deductibility of the optional donation is subject to applicable local laws and regulations. Please consult with a tax professional in your region.
      </p>
    </div>
  );
};
